// EmailConfirmationSection component for checkout flow

interface EmailConfirmationSectionProps {
  email: string | undefined
  emailConfirmed: boolean
  onEmailConfirmedChange: (confirmed: boolean) => void
  newEmail: string
  onNewEmailChange: (email: string) => void
}

export function EmailConfirmationSection({
  email,
  emailConfirmed,
  onEmailConfirmedChange,
  newEmail,
  onNewEmailChange,
}: EmailConfirmationSectionProps) {
  return (
    <div className="form-section mb-4" data-field-id="email-confirmation">
      <label className="form-label">
        <span>
          EMAIL ADDRESS{' '}
          <span className={`required${emailConfirmed || newEmail.trim() !== '' ? ' filled' : ''}`}>
            *
          </span>
        </span>
      </label>
      <div className="email-display-box">{email || 'No email provided'}</div>
      <label className="checkbox-label" style={{ marginTop: '12px' }}>
        <input
          type="checkbox"
          className="checkbox-input"
          checked={emailConfirmed}
          onChange={(e) => onEmailConfirmedChange(e.target.checked)}
        />
        <span className="checkbox-text">Yes, this is my email address</span>
      </label>
      {!emailConfirmed && (
        <div style={{ marginTop: '12px' }}>
          <label className="form-label">
            <span>
              NEW EMAIL ADDRESS{' '}
              <span className={`required${newEmail.trim() !== '' ? ' filled' : ''}`}>*</span>
            </span>
          </label>
          <input
            type="email"
            className={`form-input${newEmail.trim() !== '' ? ' field-filled' : ''}`}
            placeholder="Enter new email address"
            value={newEmail}
            onChange={(e) => onNewEmailChange(e.target.value)}
            required
          />
        </div>
      )}
    </div>
  )
}
